let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ex0Cl")).then(() => parcelRequire('5LyIQ'));